/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Dialog as MUIDialog, styled } from '@material-ui/core';

export const StyledDialog = styled(MUIDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    boxShadow: `0 1px 1px ${theme.palette.grey[200]}`,
    paddingTop: theme.spacing(3),
    borderRadius: 10,
  },
  '& .MuiDialog-paperWidthXs': {
    maxWidth: theme.spacing(32),
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: theme.spacing(64),
  },
  '& .MuiDialog-paperWidthMd': {
    maxWidth: theme.spacing(106),
  },
  '& .MuiDialog-paperWidthLg': {
    maxWidth: theme.spacing(120),
  },
  '& .MuiDialog-paperWidthXl': {
    maxWidth: theme.spacing(150),
  },
}));
